import React from "react";
import { MobileBottomButton, MobileScreen, MobileTopBar } from "./MobileScreenAtm.styles";
function MobileScreenAtm(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(MobileScreen, null, /*#__PURE__*/React.createElement(MobileTopBar, null), /*#__PURE__*/React.createElement(MobileBottomButton, null), children);
}
export default MobileScreenAtm;